import { PageState } from './types'

/** Hero title for each page state. */
export const titleForState = (s: PageState): string => {
	switch (s) {
		case 'idle':
			return 'Import to your itinerary'
		case 'processing':
			return 'Adding to your itinerary'
		case 'success':
			return 'Trip booked! Mission accomplished'
		case 'no_events':
			return "Couldn't find any events"
		case 'failed':
			return 'Import failed'
		case 'rate_limit':
			return 'Daily import limit reached'
		case 'stuck':
			return 'Looks like that import got stuck'
	}
}

/** Hero subtitle for each page state. */
